'use es6';

import { createAction } from 'redux-actions';
import actionTypes from '../constants/actionTypes';
import { formatOwnersResponse } from '../data/owners-logic';
import { fetchCreateAndOwnHubUsers } from '../api/createAndOwnHubUsersApi';
const ownersRequested = createAction(actionTypes.OWNERS_REQUESTED);
const ownersSucceeded = createAction(actionTypes.OWNERS_SUCCEEDED);
const ownersFailed = createAction(actionTypes.OWNERS_FAILED);
export const getOwners = () => {
  return dispatch => {
    dispatch(ownersRequested());
    return fetchCreateAndOwnHubUsers().then(createOwnHubUsers => {
      const formatted = formatOwnersResponse(createOwnHubUsers);
      dispatch(ownersSucceeded(formatted));
      return formatted;
    }).catch(exception => {
      // eslint-disable-next-line no-console
      console.error(exception);
      dispatch(ownersFailed(exception));
    });
  };
};